import axios from 'axios';

const BASE_URL = 'https://judge0-ce.p.rapidapi.com/submissions';
const HEADERS = {
  'x-rapidapi-key': '12bb07a588mshcf32d2ee8980621p147adfjsnc8eacadaaa8d',
  'x-rapidapi-host': 'judge0-ce.p.rapidapi.com',
  'Content-Type': 'application/json'
};

// 使用浏览器的 btoa 和 atob 函数进行 Base64 编解码
const encodeBase64 = (str) => btoa(unescape(encodeURIComponent(str)));
const decodeBase64 = (str) => decodeURIComponent(escape(atob(str)));

export const submitCode = async (sourceCode, languageId = 52, stdin = '') => {
  const response = await axios.post(`${BASE_URL}`, {
    language_id: languageId, // 可以指定不同语言的ID
    source_code: encodeBase64(sourceCode),
    stdin: encodeBase64(stdin),
  }, {
    headers: HEADERS,
    params: {
      base64_encoded: 'true',
      wait: 'false'
    }
  });
  
  return response.data;
};

export const getResult = async (token) => {
  const response = await axios.get(`${BASE_URL}/${token}`, {
    headers: HEADERS,
    params: {
      base64_encoded: 'true',
      fields: '*'
    }
  });
  
  // 如果结果包含编码的数据，解码它
  if (response.data.stdout) {
    response.data.stdout = decodeBase64(response.data.stdout);
  }
  if (response.data.stderr) {
    response.data.stderr = decodeBase64(response.data.stderr);
  }
  if (response.data.compile_output) {
    response.data.compile_output = decodeBase64(response.data.compile_output);
  }
  
  return response.data;
}; 